import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export default function NotFound() {
  return (
    <div className="p-8 min-h-[60vh] grid place-items-center" data-testid="not-found-page">
      <div className="text-center space-y-3">
        <Compass className="h-8 w-8 text-[#B45309] mx-auto" />
        <h1 className="font-editorial text-3xl tracking-tight">Page not found</h1>
        <p className="text-sm text-[#57534E] max-w-md">
          That link doesn't lead anywhere in NJM Platform — it may be outdated or mistyped.
        </p>
        <Link to="/" data-testid="not-found-home-link" className="inline-block mt-2 rounded-md bg-[#FFC817] px-4 py-2 text-sm font-medium text-[#1C1C1E] hover:bg-[#E6B415]">
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}
